define('models/transfer/suggestions_collection',[
	'backbone',
	'models/transfer/suggestion'
], function(Backbone, Suggestion) {
	var SuggestionsCollection = Backbone.Collection.extend({
		
		model: Suggestion,
		
		url: function(){
			return pf.url + '/Users/' + this.UGID + '/Transfers/Suggestions?top=' + this.limit
		},
		
		initialize: function(options) {
			options || (options = {});
			this.UGID = options.UGID;
			this.limit = options.limit;
		}
	});
	
	return SuggestionsCollection;
});

